// extracted by mini-css-extract-plugin
export var quillEditor = "_p9-1";
export var variable = "_p9-0";